module.exports = __webpack_public_path__ + "media/assets/img/portrait/small/avatar-default-36bc0ccc8fe6acabadd74baec80415a0.jpg";